import { useContext } from 'react'
import { useFieldArray } from 'react-hook-form';
import { FnAxios, FnDialog } from 'utilities/utilities';
import { TextFieldInputNumber, onCheckRequireInRowReturn } from '../../fnTickit';
import { TableContainer, Paper, Table, TableHead, TableRow, TableCell, TableBody } from '@mui/material';
import { SelectItem } from 'components/Input/Select/SelectItem';
import _ from "lodash";
import { ProviderSoldTicket } from '../../TicketSold/TicketSoldForm';

const TableReturnTicket = () => {

    //#region Hook
    const AxiosFn = FnAxios()
    const DialogFn = FnDialog();
    // #endregion

    const {
        statusId,
        isView,
        form,
        objMuseum,
        nUserType,
        setIsreRender,
        lstTotalTicketSell,

    } = useContext(ProviderSoldTicket);

    const { control, setValue, watch, clearErrors, reset } = form;

    const { fields } = useFieldArray({
        control,
        name: "lstReturnTicket"
    });
    const watchFieldArray = watch("lstReturnTicket");
    const controlledFields = fields.map((field, index) => {

        let indexTypeTicket = lstTotalTicketSell.findIndex(f => f.nTicketTypeID === watchFieldArray[index].nTicketTypeID);
        let deepClone = lstTotalTicketSell[indexTypeTicket].lstOptionTicketCheck;
        let nReturnTicket = _.countBy(deepClone, obj => (obj.nStatusTicketId === 5 || obj.nStatusTicketId === 1));

        let startbookReturn = watchFieldArray[index].nStartBook
        let endbookReturn = watchFieldArray[index].nEndBook
        let startticketReturn = watchFieldArray[index].nStartTicketID
        let endticketReturn = watchFieldArray[index].nEndTicketID
        let groupCountBookReturn = _.chain(deepClone)
            // .filter(obj => (obj.nStatusBookId === 5 || obj.nStatusBookId == null))       //Fix 26/8/2024 cal Total mistake
            .filter(obj => obj.nBookId >= startbookReturn && obj.nBookId <= endbookReturn && obj.nTicketId >= startticketReturn && obj.nTicketId <= endticketReturn && (obj.nStatusBookId === 5 || obj.nStatusBookId == null))
            .groupBy('nBookId')
            .mapValues(group => {
                const nTicketPerBook = group[0]?.nTicketPerBook;        //Fix 26/8/2024 cal Total mistake
                return { nTicketPerBook: nTicketPerBook, value: group.length === nTicketPerBook ? group.length : null };
            })
            .value();

        let nTotalTicket = nReturnTicket.true ?? 0;

        const filterNull = _.pickBy(groupCountBookReturn, item => item.value !== null);
        let nTotalBook = Object.keys(filterNull).length ?? 0;
        let isCalDisplay = startticketReturn && startticketReturn !== 0 && endticketReturn && endticketReturn !== 0
        // let nTotalBook = Object.keys(groupCountBookReturn).length ?? 0;    //Fix 26/8/2024 cal Total mistake
        if (statusId === 0 || statusId === 4) {
            //cal again 
            // watchFieldArray[index].nBookReturn = nTotalBook;
            // watchFieldArray[index].nTicketReturn = nTotalTicket;
            watchFieldArray[index].nTotalTicket = isCalDisplay ? nTotalTicket : 0;
            watchFieldArray[index].nTotalBook = isCalDisplay ? nTotalBook : 0;
            return {
                ...field,
                ...watchFieldArray[index],
            };
        }
        return {
            ...field,
            ...watchFieldArray[index],
        };
    });

    const handleOnchange = (eValue, index, sInput) => {
        if (watchFieldArray[index].nStartBook && watchFieldArray[index].nEndBook) {
            let changeBook = sInput === "nStartBook" || sInput === "nEndBook"
            calculateTicketBook(index, changeBook);
        }
        let isRequire = onCheckRequireInRowReturn(watchFieldArray[index]);
        setValue(`lstReturnTicket.${index}.isRequire`, isRequire);

        if (!isRequire || (!watchFieldArray[index].nStartBook && !watchFieldArray[index].nEndBook)) {

            let indexTypeTicket = lstTotalTicketSell.findIndex(f => f.nTicketTypeID === watchFieldArray[index].nTicketTypeID)
            if (indexTypeTicket > -1) {
                lstTotalTicketSell[indexTypeTicket].lstOptionTicketCheck.forEach(eleTicket => {
                    //book
                    if (eleTicket.nStatusBookId === 5) {
                        eleTicket.nStatusBookId = null;
                    }
                    //ticket
                    if (eleTicket.nStatusTicketId === 5) {
                        eleTicket.nStatusTicketId = null;
                    }
                });
            }

            watchFieldArray[index].nTotalBook = null;
            watchFieldArray[index].nTotalTicket = null;
            watchFieldArray[index].sAmount = "";

            //Compare
            watchFieldArray[index].nBookReturn = null;
            watchFieldArray[index].nTicketReturn = null;

            watchFieldArray[index].nStartTicketID = null;
            watchFieldArray[index].nEndTicketID = null;

            watchFieldArray[index].lstOptionBookStart = watchFieldArray[index].lstOptionBook;
            watchFieldArray[index].lstOptionBookEnd = watchFieldArray[index].lstOptionBook;
            clearErrors(`lstReturnTicket.${index}`)
            setValue(`lstReturnTicket.${index}.isRequire`, false);
            reset({
                ...watch(),
            });
        }


        if (watchFieldArray[index].nStartBook) {
            let lstFilterBook = _.filter(watchFieldArray[index].lstOptionBook, function (o) { return o.value >= watchFieldArray[index].nStartBook });
            watchFieldArray[index].lstOptionBookEnd = lstFilterBook;
            let lstFilterTicket = _.filter(watchFieldArray[index].lstOptionTicket, function (o) { return o.nParentID === watchFieldArray[index].nStartBook });
            watchFieldArray[index].lstOptionTicketStart = lstFilterTicket;
        }

        if (watchFieldArray[index].nEndBook) {
            let lstFilterBook = _.filter(watchFieldArray[index].lstOptionBook, function (o) { return o.value <= watchFieldArray[index].nEndBook });
            watchFieldArray[index].lstOptionBookStart = lstFilterBook;
            let lstFilterTicket = _.filter(watchFieldArray[index].lstOptionTicket, function (o) { return o.nParentID === watchFieldArray[index].nEndBook });
            watchFieldArray[index].lstOptionTicketEnd = lstFilterTicket;

        }

        if (watchFieldArray[index].nStartTicketID) {
            let lstFilterTicket = _.filter(watchFieldArray[index].lstOptionTicket, function (o) { return o.value >= watchFieldArray[index].nStartTicketID });
            watchFieldArray[index].lstOptionTicketEnd = lstFilterTicket;
        }

        if (watchFieldArray[index].nEndTicketID) {
            let lstFilterTicket = _.filter(watchFieldArray[index].lstOptionTicket, function (o) { return o.value <= watchFieldArray[index].nEndTicketID });
            watchFieldArray[index].lstOptionTicketStart = lstFilterTicket;
        }
    }

    const calculateTicketBook = (index, isBook) => {
        let nMuseumId = nUserType !== 1 && form.getValues("nMuseumID") ? form.getValues("nMuseumID") : objMuseum.nMuseumID;
        let param = {
            nTicketTypeID: watchFieldArray[index].nTicketTypeID,
            nMuseum: nMuseumId,
            nStartBookID: watchFieldArray[index].nStartBook,
            nEndBookID: watchFieldArray[index].nEndBook,
            nStartTicketID: isBook ? 0 : watchFieldArray[index].nStartTicketID ?? 0,
            nEndTicketID: isBook ? 0 : watchFieldArray[index].nEndTicketID ?? 0,
            nSoldDate: form.getValues("dSoldTicket").valueOf(),
            isCheckPrice: false
        }

        AxiosFn.Get(`SoldTicket/GetCalculateSoldTicket`, param, (result) => {
            let objResult = result.objResult;
            //set value in list
            watchFieldArray[index].nStartTicket = objResult.nTicketMin;
            watchFieldArray[index].nEndTicket = objResult.nTicketMax;
            watchFieldArray[index].nStartTicketID = objResult.nTicketMinId;
            watchFieldArray[index].nEndTicketID = objResult.nTicketMaxId;


            watchFieldArray[index].lstOptionTicket = objResult.lstOptionTicket;
            watchFieldArray[index].lstOptionTicketStart = objResult.lstOptionTicketStart;
            watchFieldArray[index].lstOptionTicketEnd = objResult.lstOptionTicketEnd;

            watchFieldArray[index].sAmount = "";

            let nTicketTypeID = watchFieldArray[index].nTicketTypeID;
            let nStartBookID = watchFieldArray[index].nStartBook;
            let nEndBookID = watchFieldArray[index].nEndBook;
            let nStartTicketID = watchFieldArray[index].nStartTicketID;
            let nEndTicketID = watchFieldArray[index].nEndTicketID

            let indexTypeTicket = lstTotalTicketSell.findIndex(f => f.nTicketTypeID === nTicketTypeID)
            if (indexTypeTicket > -1) {
                lstTotalTicketSell[indexTypeTicket].lstOptionTicketCheck.forEach(eleTicket => {
                    //book
                    if (eleTicket.nBookId >= nStartBookID && eleTicket.nBookId <= nEndBookID) {
                        if (eleTicket.nStatusBookId == null) {
                            eleTicket.nStatusBookId = 5;
                        }
                    }
                    else if (eleTicket.nStatusBookId === 5) {
                        eleTicket.nStatusBookId = null;
                    }
                    //ticket
                    if (eleTicket.nTicketId >= nStartTicketID && eleTicket.nTicketId <= nEndTicketID) {
                        if (eleTicket.nStatusTicketId == null) {
                            eleTicket.nStatusTicketId = 5;
                        }
                    }
                    else if (eleTicket.nStatusTicketId === 5) {
                        eleTicket.nStatusTicketId = null;
                    }
                });

                let deepClone = lstTotalTicketSell[indexTypeTicket].lstOptionTicketCheck;
                let nReturnTicket = _.countBy(deepClone, obj => obj.nStatusTicketId === 5);

                let groupCountBookReturn = _.chain(deepClone)
                    .groupBy('nBookId')
                    .mapValues(group => group.length)
                    .value();

                watchFieldArray[index].nTotalBook = Object.keys(groupCountBookReturn).length;
                watchFieldArray[index].nTotalTicket = nReturnTicket.true ?? 0;
            }

            reset({
                ...watch(),
            });
            setIsreRender(value => !value)


            DialogFn.UnBlockUI();
        });
    }


    return (
        <TableContainer id='table-receive' component={Paper}>
            <Table sx={{ minWidth: 1200 }} >
                <TableHead>
                    <TableRow>
                        <TableCell component="th" padding='none' rowSpan={2} style={{ minWidth: '40px', width: '40px' }}>ที่</TableCell>
                        <TableCell component="th" padding='none' rowSpan={2} style={{ minWidth: '250px', width: '250px' }}>ประเภทบัตร</TableCell>
                        <TableCell component="th" padding='none' colSpan={2}>เล่มที่</TableCell>
                        <TableCell component="th" padding='none' colSpan={2}>เลขที่</TableCell>
                        <TableCell component="th" padding='none' rowSpan={2} style={{ minWidth: '120px', width: '120px' }}>จำนวนเล่ม</TableCell>
                        <TableCell component="th" padding='none' rowSpan={2} style={{ minWidth: '120px', width: '120px' }}>จำนวนใบ</TableCell>
                    </TableRow>
                    <TableRow>
                        <TableCell component="th" padding='none' style={{ minWidth: '150px', width: '150px' }}>เริ่มต้น</TableCell>
                        <TableCell component="th" padding='none' style={{ minWidth: '150px', width: '150px' }}>สิ้นสุด</TableCell>
                        <TableCell component="th" padding='none' style={{ minWidth: '150px', width: '150px' }}>เริ่มต้น</TableCell>
                        <TableCell component="th" padding='none' style={{ minWidth: '150px', width: '150px' }}>สิ้นสุด</TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {
                        controlledFields.map((row, index) => {
                            const fieldName = `lstReturnTicket.${index}`;
                            const RowRequire = row.isRequire;
                            let isCalDisplay = row.nStartTicketID && row.nStartTicketID !== 0 && row.nEndTicketID && row.nEndTicketID !== 0
                            return (
                                <TableRow key={`${fieldName}.sID`}>
                                    <TableCell align="center" >{index + 1}</TableCell>
                                    <TableCell align="left">
                                        {row.sTypeTicket}
                                    </TableCell>
                                    <TableCell >
                                        <SelectItem
                                            id={`${fieldName}.nStartBook`}
                                            name={`${fieldName}.nStartBook`}
                                            defaultValue={row.nStartBook}
                                            required={RowRequire}
                                            options={row.lstOptionBookStart}
                                            disabled={isView}
                                            onChange={(e) => handleOnchange(e, index, "nStartBook")}
                                            IsShowMessageError={false}
                                        />
                                    </TableCell>
                                    <TableCell >
                                        <SelectItem
                                            id={`${fieldName}.nEndBook`}
                                            name={`${fieldName}.nEndBook`}
                                            defaultValue={row.nEndBook}
                                            required={RowRequire}
                                            options={row.lstOptionBookEnd}
                                            disabled={isView}
                                            onChange={(e) => handleOnchange(e, index, "nEndBook")}
                                            IsShowMessageError={false}
                                        />
                                    </TableCell>
                                    <TableCell >
                                        <SelectItem
                                            id={`${fieldName}.nStartTicketID`}
                                            name={`${fieldName}.nStartTicketID`}
                                            defaultValue={row.nStartTicketID}
                                            required={RowRequire}
                                            options={row.lstOptionTicketStart}
                                            disabled={isView || !row.nStartBook}
                                            onChange={(e) => handleOnchange(e, index, "nStartTicketID")}
                                            IsShowMessageError={false}
                                        />
                                    </TableCell>
                                    <TableCell >
                                        <SelectItem
                                            id={`${fieldName}.nEndTicketID`}
                                            name={`${fieldName}.nEndTicketID`}
                                            defaultValue={row.nEndTicketID}
                                            required={RowRequire}
                                            options={row.lstOptionTicketEnd}
                                            disabled={isView || !row.nEndBook}
                                            onChange={(e) => handleOnchange(e, index, "nEndTicketID")}
                                            IsShowMessageError={false}
                                        />
                                    </TableCell>
                                    <TableCell >
                                        <TextFieldInputNumber value={isCalDisplay ? row.nTotalBook : null} digit={0} />
                                    </TableCell>
                                    <TableCell >
                                        <TextFieldInputNumber value={isCalDisplay ? row.nTotalTicket : null} digit={0} />
                                    </TableCell>
                                </TableRow>
                            )
                        })
                    }
                    {
                        controlledFields.length === 0 ?
                            <TableRow >
                                <TableCell align="center" colSpan={8}>ไม่พบข้อมูล</TableCell>
                            </TableRow>
                            :
                            null
                    }
                </TableBody>
            </Table>
        </TableContainer>

    )
}

export default TableReturnTicket
